@if (!hasNoData) {
  <sd-rich-paragraph
    [isLoading]="isLoading"
    [contentData]="card?.content"
    [isDescription]="isDescription"
    #content
    [textConfig]="card?.content?.heading?.textConfig
      ? card?.content?.heading?.textConfig
      : positionEnum.left"
    [parentsThemesConfig]="themesConfig"
    [titleLevel]="titleLevel"
    [size]="visualTextSize"
    [brand]="brand"
  />
}

@if (card?.media) {
  <sd-banner
    [isComponentLoading]="isLoading"
    class="is-main {{ hasNoData ? 'has-no-overlay' : '' }}"
    #banner
    (mediaPlay)="onVideoPlayed(card)"
    (mediaEnded)="onVideoEnded(card)"
    [isAriaHidden]="true"
    [isButtonSmall]="true"
    [hasModal]="hasModal"
    [media]="card?.media"
    [videoTitle]="card?.content?.heading?.data?.title"
    [hasAltText]="false"
    [imgRatio]="card?.imageRatio"
    [twicPicsAutoSize]="twicPicsAutoSize"
  />
}
